import { render, staticRenderFns } from "./SettingsDemo.vue?vue&type=template&id=3362fd9c"
import script from "./SettingsDemo.vue?vue&type=script&lang=js"
export * from "./SettingsDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports